import { render, staticRenderFns } from "./subAddress.vue?vue&type=template&id=0517ef3e&scoped=true"
import script from "./subAddress.vue?vue&type=script&lang=js"
export * from "./subAddress.vue?vue&type=script&lang=js"
import style0 from "./subAddress.vue?vue&type=style&index=0&id=0517ef3e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0517ef3e",
  null
  
)

export default component.exports